import { ListCloneJobsResponseSchema } from './list-clone-jobs.schema';
/**
 * List Clone Jobs Endpoint Contract
 * Returns every unfinished tenant clone job. Restricted to super-admins.
 *
 * The polling surface for an asynchronous clone: the tenant list page polls it
 * while any job is open and stops when the list comes back empty. A finished
 * clone deletes its job, so an empty response is the completion signal.
 *
 * Its own top-level path rather than a segment under `tenants`: hanging a
 * literal `clone-jobs` off a controller path that also carries `:tenantId`
 * routes creates a global, order-dependent shadowing invariant that is
 * invisible at every place it can be broken.
 */ export const listCloneJobsContract = {
    method: 'GET',
    path: '/api/v2/tenant-clone-jobs',
    description: 'List unfinished tenant clone jobs (super-admin only)',
    responseSchema: ListCloneJobsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin'
        }
    }
};

//# sourceMappingURL=list-clone-jobs.contract.js.map